import { combineReducers, createSlice } from "@reduxjs/toolkit";
import { applyModelsReducers } from "./apply-models";
import { cashflowReducers, initialState as modelEditingInitialState } from "./model-editing";
import { taReducers } from "./ta-model-editing";
export const initialState = {
    addCustomModelFromExcel: false
};
const slice = createSlice({
    initialState,
    name: "modelListReducers",
    reducers: {
        setAddCustomModelFromExcel: (state) => {
            state.addCustomModelFromExcel = true;
        },
        setModelForPrepopulation: (state, action) => {
            state.selectedDefaultModelForPrepopulate = action.payload.id;
        },
        unsetAddCustomModelFromExcel: (state) => {
            state.addCustomModelFromExcel = false;
        },
        unsetModelForPrepopulation: (state) => {
            delete state.selectedDefaultModelForPrepopulate;
        }
    }
});
export const cashflowForecastingReducers = combineReducers({
    applyModelsState: applyModelsReducers,
    modelEditingState: cashflowReducers,
    modelListState: slice.reducer,
    taModelEditingState: taReducers
});
export const { setAddCustomModelFromExcel, unsetAddCustomModelFromExcel, setModelForPrepopulation, unsetModelForPrepopulation } = slice.actions;
export const adminCFF = "adminCFF";
export const timeSeriesPreviewChart = "timeSeriesPreviewChart";
export const transparencyBreakdownChart = "transparencyBreakdownChart";
export const resetCashflowForecastingState = (state, isNew) => {
    if (!isNew) {
        state.modelEditingState.present = { ...modelEditingInitialState };
        state.modelEditingState.past = [];
        state.modelEditingState.future = [];
        state.taModelEditingState.model = {};
        state.modelEditingState.present.isNameInvalid = false;
    }
};
